import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Hundreds of ideas, most written for a single level', 'Games that need every resident to read, talk or follow along', 'Nothing for the resident who sleeps or no longer joins the group', 'Memberships that commonly run about $75 to $200 a year', 'You adapt every activity yourself, on your own time'];
const withIt = ['90 activities, each written at DO, HELP and FEEL', 'A Three-Way Session you can lead from memory', 'FEEL versions that double as 1:1 room visits', 'One payment — no subscription, no certification required', 'Runs with what your community already has'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-311" data-mp="2d80sil0rpaeo">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-312" data-mp="30yeq0r24g1gn">
        <div className="text-center" data-id="element-313" data-mp="30x3l2nwxwnny">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-314" data-mp="35ov2a7u7hh1f">
            Why this isn&apos;t another activity list
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-315" data-mp="1tfmmekpapj1c">
            A pile of ideas vs{' '}
            <span className="italic text-coral-deep" data-id="element-316" data-mp="2367set7atpua">one activity, three ways</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-317" data-mp="1ydeo26fqsjiq">
            Most activity resources sell volume: hundreds of ideas for “seniors”.
            Volume was never the hard part. The hard part is an activity that
            still works when half the room can’t follow it.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-318" data-mp="2h4fkonte42z4">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-319" data-mp="rp7t3dmjaaqr">
            <h3 className="font-display text-base font-bold text-ink-soft sm:text-xl" data-id="element-320" data-mp="rs3tr9prndiw">
              A “300+ activities” list or a membership
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-321" data-mp="2mu7f7q1qa9nz">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-ink-soft sm:text-sm" data-id="element-322" data-mp="2rtabom3n77kc">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-323" data-mp="30sp2jmnq1k5d">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-324" data-mp="35sthv9cw88u0" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-325" data-mp="3jjf3h5tqewvl">
            <h3 className="font-display text-base font-bold text-gold sm:text-xl" data-id="element-326" data-mp="3jin7htw82x4s">
              Memory Care Activity Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-327" data-mp="3thcqjpzuunmm">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-328" data-mp="7g5fdtm5pgsa">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/25" data-id="element-329" data-mp="2fr5e60zvwrm">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-330" data-mp="3tp6krsd6p9nc" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}